export type Category = 'earrings' | 'necklaces' | 'rings';

export const CATEGORIES: Category[] = ['earrings', 'necklaces', 'rings'];

export interface Product {
  slug: string;
  category: Category;
  name: string;
  price: number;
  description: string;
  materials: string;
  imageIds: string[];
}

// Each value is a Cloudinary public ID — paste whatever the dashboard shows
// (e.g. "Green_Double_Grey_Original_wiumdj"). Leave empty to fall back to the
// first product image in that category via heroForCategory().
export const categoryHeroes: Partial<Record<Category, string>> = {
  rings: "Bkue_Float_Original_pdiiii",
  necklaces: "lock_hang_e4xpga",
  earrings: "lotus_lay_sjfjnr"
};

export const categoryLabels: Record<Category, string> = {
  earrings: 'Earrings',
  necklaces: 'Necklaces',
  rings: 'Rings',
};


// {
//   slug: '',
//   category: '',
//   name: '',
//   price: ,
//   materials: '',
//   description: '',
//   imageIds: []
// }
export const products: Product[] = [
  // necklaces
  {
    slug: 'tooth_copper',
    category: 'necklaces',
    name: 'Copper Fang',
    price: 150,
    description: 'Light chain complemented by poised copper fang.',
    materials: 'Copper',
    imageIds: ['Cop_Tooth_Hang_ewmply', 'Cop_Tooth_hvbjho']
  },
    {
    slug: 'tooth_silver',
    category: 'necklaces',
    name: 'Silver Fang',
    price: 150,
    description: 'Light chain complemented by poised silver fang.',
    materials: 'Silver',
    imageIds: ['Tooth_Hang_Original_tbd0hf', 'Silv_Tooth_jrhvp9']
  },
  {
    slug: 'gold_star_blue',
    category: 'necklaces',
    name: 'Copper Star - Blue',
    price: 80,
    description: 'Light beaded chain with classic star',
    materials: 'Copper',
    imageIds: ['Blue_Fleur_Hang_emnsvu', 'Blue_Fleur_Wear_xyt48g'],
  },
    {
    slug: 'bell_flower_blue',
    category: 'necklaces',
    name: 'Blue Bell Flower',
    price: 80,
    description: '',
    materials: 'Bead, Copper',
    imageIds: ['Blue_Flower_Hang_wjs942', 'Blue_Flower_Wear_ybu77n', 'Flower_Lay_Original_uokqim'],
  },
  // Earrings
    {
    slug: 'blue_drops_gold',
    category: 'earrings',
    name: 'Deep Sea Dropplets - Gold',
    price: 120,
    materials: 'Agate, Gold',
    description: 'Water Dropplets hanging from gold.',
    imageIds: ['gold_tear_hang_ddap6n', 'godl_tear_white_ear_xrfi88', 'gold_lay_bmvgz4'],
  },
    {
    slug: 'blue_drops_silver',
    category: 'earrings',
    name: 'Deep Sea Dropplets - Silver',
    price: 120,
    materials: 'Agate, Silver',
    description: 'Water Dropplets hanging from silver.',
    imageIds: ['silv_tear_hang_afyrmz', 'blue_tear_white_ear_kvhhqn', 'blue_tear_lay_bgtqea'],
  },
  { slug: 'blue_transparent',
    category: 'earrings',
    name: "Pillar - Blue",
    price: 150,
    materials: 'Sea glass, gold',
    description: 'Frozen glacier blue on gold wiring.',
    imageIds: ['Blue_hang_yl2foo', 'blue_ear_white_ohfxlw', 'blue_lay_rs1anr']
  },
  // Rings
  {
    slug: 'light_blue_inset',
    category: 'rings',
    name: 'Sea Blue Inset',
    price: 120,
    materials: 'Gold, Silver, Stone',
    description: '',
    imageIds: ['Light_Blue_Ring_Lay_Original_lfhe04', 'Light_Blue_Profile_lduzee']
  },
    {
    slug: 'pink_inset',
    category: 'rings',
    name: 'Nude Pink Inset',
    price: 120,
    materials: 'Gold, Silver, Stone',
    description: '',
    imageIds: ['pink_stand_Original_xs6oia']
  }
];

export const isCategory = (value: string | undefined): value is Category =>
  value === 'earrings' || value === 'necklaces' || value === 'rings';

export const productsByCategory = (c: Category): Product[] =>
  products.filter((p) => p.category === c);

export const findProduct = (c: Category, slug: string): Product | undefined =>
  products.find((p) => p.category === c && p.slug === slug);

export const heroForCategory = (c: Category): string | undefined =>
  categoryHeroes[c] ?? productsByCategory(c)[0]?.imageIds[0];
